<template>
	<div class="border-b border-gray-200 w-full" style="text-wrap: pretty;">
		<!-- Accordion Trigger Button -->
		<button
			type="button"
			@click="$emit('toggle')"
			class="w-full flex justify-between items-center py-5 text-left font-medium text-[#303030] hover:text-[#244D13] focus:outline-none transition-colors bg-white px-4"
			:aria-expanded="isOpen ? 'true' : 'false'"
		>
			<span class="text-base md:text-lg pr-4">{{ question }}</span>
			
			<!-- Chevron icon toggles orientation based on open state -->
			<svg
				class="h-5 w-5 text-gray-500 transform transition-transform duration-300 flex-shrink-0"
				:class="{ 'rotate-180 text-[#244D13]': isOpen }"
				fill="none"
				viewBox="0 0 24 24"
				stroke="currentColor"
			>
				<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
			</svg>
		</button>

		<!-- Refactored: CSS Grid Smooth Expandable Wrapper -->
		<div
			class="grid transition-all duration-300 ease-in-out"
			:class="isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
		>
			<!-- Critical: This inner wrapper needs min-height 0 to make grid collapse work -->
			<div class="overflow-hidden">
				<div class="text-sm md:text-base text-gray-600 leading-relaxed bg-white px-4 py-5 border-t border-gray-200">
					<!-- Slot allows HTML. Falls back to prop text if no slot content is passed. -->
					<slot>{{ answer }}</slot>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'DynamicDropdown',
	props: {
		question: {
			type: String,
			required: true
		},
		answer: {
			type: String,
			default: '' // Changed to optional fallback since slots are preferred now
		},
		isOpen: {
			type: Boolean,
			default: false
		}
	}
};
</script>
